import {createStore, applyMiddleware} from 'redux'

import createSagaMiddleware from 'redux-saga'

import rootReducer from './redux/reducer'

import rootSaga from './redux/saga'

const sagaMiddleware = createSagaMiddleware()

const store = createStore(rootReducer, applyMiddleware(sagaMiddleware))

sagaMiddleware.run(rootSaga);

export default store